import { getEnv } from 'common/utils';
import { AddVersionType } from 'common/types';
import { FosAxiosInstance, FosTokenAxiosInstance } from 'common/service/axiosInstances';

const fosHost = getEnv().fosHost;
const prefix = '/object-upload';
const fosServer = {
  startVersionDccChecking(uuid, task_id, description, attachments, modifyFileList) {
    return FosAxiosInstance.post(`${prefix}/api/uploadEnd`, {
      uuid,
      task_id,
      description,
      attachments: JSON.stringify(attachments),
      modifyFileList,
    });
  },
  //上传资产后触发质检接口
  startAssetDccChecking(params: { uuid; templateId; modifyFileList; taskName; type: AddVersionType }) {
    const { uuid, templateId, modifyFileList, taskName, type } = params;
    return FosAxiosInstance.post(`${prefix}/api/uploadAssetEnd`, {
      uuid,
      templateId,
      modifyFileList,
      taskName,
      type,
    });
  },
  //资产入库
  startAssetStore(params: { uuid: string; price: number; assetName: string; sourceProject?: string; tags?: string[] }) {
    const { uuid, assetName, price, sourceProject, tags } = params;
    return FosAxiosInstance.post(`${prefix}/api/addAsset`, {
      uuid,
      price,
      assetName,
      tags,
      sourceProject,
    });
  },
  fosLogin(rbacToken: string, user: string) {
    if (!fosHost) return;
    return FosTokenAxiosInstance.post(
      `/login`,
      {
        token: rbacToken,
        user: user,
      },
      {
        withCredentials: true,
      },
    );
  },
  fosLogout() {
    if (!fosHost) return Promise.resolve();
    return FosTokenAxiosInstance.get(`/logout`, { withCredentials: true });
  },
};

export default fosServer;
